export function download(src: string, filename: string) {
  if (src) {
    const anchor = document.createElement('a');
    anchor.style.display = 'none';
    anchor.download = filename;
    anchor.href = src;
    anchor.click();
  }
}
